export default __webpack_public_path__ + "static/media/music-card.cb9fceb6.png";